export default "__VITE_ASSET__BVc1tMvs__"